__turbopack_context__.v({
  "container": "DP7_EG_container",
  "fieldName": "DP7_EG_fieldName",
  "label": "DP7_EG_label",
  "variants": "DP7_EG_variants",
});
